import React, { useState } from "react";
import { POSTER_FIELD_DESCRIPTIONS, getSectionColor } from "../../data/posterFieldDescriptions";

export default function InfoTooltip({ fieldKey }) {
  const field = POSTER_FIELD_DESCRIPTIONS[fieldKey];
  const [visible, setVisible] = useState(false);

  if (!field) return null;

  const color = getSectionColor(fieldKey);

  return (
    <span style={{ position: "relative", display: "inline-block", marginLeft: 4 }}>
      <span
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        style={{ cursor: "help", opacity: 0.6, fontSize: "inherit", userSelect: "none" }}
        aria-label={`Info: ${field.label}`}
      >
        ⓘ
      </span>
      {visible && (
        <div
          style={{
            position: "absolute",
            bottom: "calc(100% + 6px)",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            background: "#1f2937",
            color: "#fff",
            padding: "8px 10px",
            borderRadius: 6,
            fontSize: 12,
            lineHeight: 1.4,
            maxWidth: 280,
            whiteSpace: "normal",
            pointerEvents: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          }}
        >
          <span
            style={{
              display: "inline-block",
              background: color,
              color: "#fff",
              borderRadius: 3,
              padding: "1px 5px",
              fontSize: 10,
              fontWeight: 700,
              marginRight: 6,
            }}
          >
            {field.code}
          </span>
          <strong>{field.label}</strong>
          <br />
          <span style={{ opacity: 0.9 }}>{field.description}</span>
        </div>
      )}
    </span>
  );
}
